/**
 * Returns true if the value is not null or undefined (and narrows the corresponding type)
 *
 * @param value any value
 * @returns true if the value is not null or undefined
 */
export const isDefined = <T>(value: T): value is Exclude<T, null | undefined> => value != null;
